import React from "react";

export const CustomIcon = ({ src, alt, width, height }) => {
  return (
    <>
      <img src={src} alt={alt} width={width} height={height} />
    </>
  );
};
